import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel
} from '@ionic/react'
import { createOutline } from 'ionicons/icons'
import React from 'react'
import { AdditionalBuilding } from '../form/additional.building.card'

interface Props {
  onEdit?: () => any
  additional: {
    buildings: AdditionalBuilding[]
  }
  building: any
}

export const BuildingCard: React.FC<Props> = (props) => {
  return (
    <IonCard>
      <IonCardHeader>
        {props.onEdit && (
          <IonButton
            style={{
              position: 'absolute',
              zIndex: 10,
              right: 10,
              top: 10,
            }}
            onClick={props.onEdit}
            fill={'clear'}
          >
            <IonIcon slot="icon-only" icon={createOutline} />
          </IonButton>
        )}
        <IonCardTitle>Gebäude</IonCardTitle>
      </IonCardHeader>

      {props.building.groundFloor > 0 && <IonItem>
        <IonLabel position="floating">Erdgesschoss m<sup>2</sup></IonLabel>
        <IonInput value={props.building.groundFloor} readonly />
      </IonItem>}

      {props.building.firstFloor > 0 && <IonItem>
        <IonLabel position="floating">1. Obergeschoss m<sup>2</sup></IonLabel>
        <IonInput value={props.building.firstFloor} readonly />
      </IonItem>}

      {props.building.secondFloor > 0 && <IonItem>
        <IonLabel position="floating">2. Obergeschoss m<sup>2</sup></IonLabel>
        <IonInput value={props.building.secondFloor} readonly />
      </IonItem>}

      {props.building.mansarde > 0 && <IonItem>
        <IonLabel position="floating">Mansarde m<sup>2</sup></IonLabel>
        <IonInput value={props.building.mansarde} readonly />
      </IonItem>}

      {props.building.basement > 0 && <IonItem>
        <IonLabel position="floating">Keller m<sup>2</sup></IonLabel>
        <IonInput value={props.building.basement} readonly />
      </IonItem>}

      {props.additional.buildings && props.additional.buildings.map(b => (
        <IonItem key={b.id}>
          <IonLabel position="floating">Versicherte Nebengebäude m<sup>2</sup></IonLabel>
          <IonInput value={`${b.name}, ${b.area}`} readonly />
        </IonItem>
      ))}
    </IonCard>
  )
}
